import { useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useLocation } from 'react-router-dom';
import { AddTaskDialog } from 'components/tasks/AddTaskDialog';
import { useTaskDrawerState } from 'components/tasks/useTaskDrawerState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const AddTaskKeyboardShortcut = () => {
    const location = useLocation();
    const triggerRef = useRef<HTMLDivElement>(null);
    const { goToTask } = useTaskDrawerState();
    const { hasGivebutterPlusAccess } = useCurrentAccount();

    useHotkeys(
        't',
        event => {
            const isFocusGuardActive = document.querySelector('[data-radix-focus-guard]');
            const isCustomElement = customElements.get(
                (event.target as HTMLElement)?.tagName?.toLowerCase() ?? '',
            );

            if (!event.repeat && !isCustomElement && !isFocusGuardActive) {
                event.preventDefault();
                triggerRef.current?.click();
            }
        },
        {
            enabled: hasGivebutterPlusAccess,
        },
    );

    return (
        <AddTaskDialog
            key={location.pathname}
            onSuccess={task => {
                goToTask(task.id);
            }}
        >
            <div ref={triggerRef} className="hidden" />
        </AddTaskDialog>
    );
};

export { AddTaskKeyboardShortcut };
